export function cleanFileName(value: string) {
  return value.replace(/[:/]+/g, '_')
}

export function downloadUrl(url: string, fileName: string) {
  const a = window.document.createElement('a')
  a.href = url

  if (fileName) {
    a.download = cleanFileName(fileName)
  }

  // Append anchor to body.
  document.body.appendChild(a)

  // Initiate download by simulating click
  a.click()

  // Remove anchor from body
  document.body.removeChild(a)
}

export function downloadFile(fileName: string, blob: Blob) {
  const url = window.URL.createObjectURL(blob)
  return downloadUrl(url, fileName)
}
